import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetail from "@/pages/ServiceDetail";
import UniversitiesHub from "@/pages/UniversitiesHub";
import SuccessStories from "@/pages/SuccessStories";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Guarantee from "@/pages/Guarantee";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/universities" element={<UniversitiesHub />} />
            <Route path="/universities/india" element={<Navigate to="/universities" replace />} />
            <Route path="/universities/europe" element={<Navigate to="/universities" replace />} />
            <Route path="/success-stories" element={<SuccessStories />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/guarantee" element={<Guarantee />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-left" richColors />
    </div>
  );
}

export default App;
